import { Button } from 'components';
import { FormError, FormWrapper, TextInput } from 'components/forms/hook-form';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';
import React from 'react';
import type { SubmitHandler } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

interface Props {
  onSubmit: SubmitHandler<LostPasswordFormValues>;
  tenantCode?: string;
}

export interface LostPasswordFormValues {
  username: string;
  tenantCode?: string;
}

const LostPasswordSubmitButton = () => {
  const {
    formState: { isSubmitting }
  } = useFormContext<LostPasswordFormValues>();
  const { t } = useCustomTranslation();

  return (
    <Button loading={isSubmitting} type="primary" htmlType="submit" className="public-btn">
      {t('password.forms.forgetPasswordButton')}
    </Button>
  );
};

const LostPasswordForm: React.FC<Props> = (props): React.ReactElement => {
  const { onSubmit, tenantCode } = props;

  const { t } = useCustomTranslation();
  const hookValidators = useValidators();

  const navigate = useNavigate();

  const defaultValues: LostPasswordFormValues = {
    username: '',
    tenantCode: ''
  };

  return (
    <FormWrapper<LostPasswordFormValues> defaultValues={defaultValues} onSubmit={onSubmit}>
      {!tenantCode && (
        <TextInput
          label={t('login.forms.tenantCodeLabel')}
          name="tenantCode"
          required
          options={{
            required: hookValidators.required,
            maxLength: hookValidators.maxLength(49),
            validate: hookValidators.tenantCode
          }}
        />
      )}
      <TextInput
        label={t('password.forms.usernameLabel')}
        name="username"
        required
        type="text"
        options={{ required: hookValidators.required }}
      />
      <FormError />
      <LostPasswordSubmitButton />
      <Button onClick={() => navigate('/login')} type="link" className="public-btn return">
        {t('password.forms.backToLoginButton')}
      </Button>
    </FormWrapper>
  );
};

export default LostPasswordForm;
